import { render, staticRenderFns } from "./BaseUser.vue?vue&type=template&id=ec7b4aca&scoped=true&"
import script from "./BaseUser.vue?vue&type=script&lang=js&"
export * from "./BaseUser.vue?vue&type=script&lang=js&"
import style0 from "./BaseUser.vue?vue&type=style&index=0&id=ec7b4aca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7b4aca",
  null
  
)

export default component.exports